import { BureauReport } from "../../../components";

function Index({ loan }) {

    const hasReport = loan?.clientCreditBureauReport !== undefined && (
        loan?.clientCreditBureauReport?.message !== "No records found! Thank You!" ||
        loan?.clientCreditBureauReport?.message !== "We are unable to process your request at this moment, please try again later or contact our customer service team, thank you!" ||
        loan?.clientCreditBureauReport?.message !== "success"
    );

    return (
        <div className="space-y-5 py-4">
            <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden">
                <div className="px-5 py-3.5 border-b border-gray-100 dark:border-gray-700">
                    <h4 className="text-sm font-semibold text-gray-700 dark:text-gray-200">Credit Bureau Report</h4>
                </div>
                <div className="overflow-x-auto">
                    <table className="min-w-full">
                        <thead>
                            <tr className="border-b border-gray-100 dark:border-gray-700 bg-gray-50/60 dark:bg-gray-900/60">
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide md:w-1/2">Requested Information</th>
                                <th scope="col" className="px-5 py-3 text-left text-xs font-semibold text-gray-400 dark:text-gray-500 uppercase tracking-wide md:w-1/2">Details</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-50 dark:divide-gray-700/50">
                            {hasReport ?
                                <BureauReport report={loan?.clientCreditBureauReport} />
                            :
                                <tr>
                                    <td colSpan={2} className="px-5 py-10 text-center text-sm text-gray-400">
                                        No records found.
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
}

export default Index;
